import {
  BaseIcon
} from "./chunk-Z3LMOCJ7.mjs";

// src/icons/networks/NetworkBase.tsx
import { forwardRef } from "react";
import { Fragment, jsx } from "react/jsx-runtime";
var NetworkBase = forwardRef(
  ({ variant = "mono", ...props }, ref) => /* @__PURE__ */ jsx(BaseIcon, { ...props, ref, children: variant === "mono" ? /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M11.983 22C17.515 22 22 17.523 22 12S17.515 2 11.983 2C6.733 2 2.428 6.03 2 11.16h13.24v1.68H2C2.428 17.97 6.734 22 11.983 22"
    }
  ) }) : /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
    "path",
    {
      fill: "#0052FF",
      d: "M11.983 22C17.515 22 22 17.523 22 12S17.515 2 11.983 2C6.733 2 2.428 6.03 2 11.16h13.24v1.68H2C2.428 17.97 6.734 22 11.983 22"
    }
  ) }) })
);
NetworkBase.displayName = "base";
var NetworkBase_default = NetworkBase;

export {
  NetworkBase_default
};
